import type { QuickStartGuideSection } from '@efdigital/ll-xceed-v2/data/coaching/coachee/quick-start-guide';
import type { TOC } from '@ember/component/template-only';

interface QuickStartGuideSectionContentSignature {
  Args: {
    section: QuickStartGuideSection;
  };
  Element: HTMLDivElement;
}

function eq(a: unknown, b: unknown): boolean {
  return a === b;
}

const QuickStartGuideSectionContent: TOC<QuickStartGuideSectionContentSignature> =
  <template>
    <div class="d-flex flex-column gap-4" ...attributes>
      {{#if @section.intro}}
        <p class="small text-body-secondary mb-0">
          {{@section.intro}}
        </p>
      {{/if}}

      {{#if (eq @section.layout "steps")}}
        <ol class="list-unstyled d-flex flex-column gap-4 mb-0">
          {{#each @section.blocks as |block|}}
            <li class="d-flex gap-3">
              <span
                class="ll-avatar-xs rounded-circle text-bg-primary d-inline-flex align-items-center justify-content-center small fw-bold flex-shrink-0"
                aria-hidden="true"
              >{{block.step}}</span>

              <div class="min-w-0 pt-1">
                <h3 class="h6 fw-semibold mb-2">{{block.title}}</h3>
                {{#if block.body}}
                  <p class="small text-body-secondary mb-0">{{block.body}}</p>
                {{/if}}
              </div>
            </li>
          {{/each}}
        </ol>
      {{else}}
        <div class="d-flex flex-column gap-4">
          {{#each @section.blocks as |block|}}
            <div
              class="d-flex
                {{if
                  block.icon
                  'align-items-start gap-3'
                  'align-items-stretch'
                }}"
            >
              {{#if block.icon}}
                <span
                  class="ll-avatar-xs rounded-circle text-bg-primary d-inline-flex align-items-center justify-content-center flex-shrink-0"
                  aria-hidden="true"
                >
                  <iconify-icon inline icon={{block.icon}} class="fs-5" />
                </span>
              {{else}}
                <span
                  class="border-start border-4 border-primary flex-shrink-0"
                  aria-hidden="true"
                ></span>
              {{/if}}
              <div class="min-w-0 flex-grow-1 {{unless block.icon 'ps-4'}}">
                <h3 class="h6 fw-semibold mb-2">{{block.title}}</h3>

                {{#if block.body}}
                  <p class="small text-body-secondary mb-0">{{block.body}}</p>
                {{/if}}

                {{#if block.items}}
                  <ul
                    class="list-unstyled mb-0 d-flex flex-column gap-2
                      {{if block.body 'mt-3'}}"
                  >
                    {{#each block.items as |item|}}
                      <li class="d-flex gap-2 small text-body-secondary mb-0">
                        <iconify-icon
                          inline
                          icon="ph:check-circle"
                          class="text-primary flex-shrink-0 mt-1"
                          aria-hidden="true"
                        />
                        <span>{{item}}</span>
                      </li>
                    {{/each}}
                  </ul>
                {{/if}}

                {{#if block.footer}}
                  <p
                    class="small text-body-secondary mb-0 mt-3"
                  >{{block.footer}}</p>
                {{/if}}
              </div>
            </div>
          {{/each}}
        </div>
      {{/if}}
    </div>
  </template>;

export default QuickStartGuideSectionContent;
